<template>

    <div class="modal"
         data-bs-backdrop="static"
         id="my_modal">
        <div class="modal-dialog" role="document">
            <div>
                <font-awesome-icon icon="spinner" size="5x" spin :style="{ color: '#dcdcdc' }"></font-awesome-icon>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {computed, defineComponent, onMounted, watch} from 'vue'

import Modal from 'bootstrap/js/dist/modal'
import {useMainStore} from "@/stores/mainStore";


export default defineComponent({
    name: "MaskModal",

    setup() {
        const mainStore = useMainStore();

        let myModal: Modal;

        onMounted(() => {
            myModal = new Modal('#my_modal', {
                keyboard: false
            })
        })

        const show = computed(() => mainStore.isShowMask)
        watch(show, (show) => {
            show ? myModal.show() : myModal.hide()
        })

        return {
            show
        }

    }
})
</script>

<style scoped>

.modal {
    position: absolute;
    z-index: 3000;
    height: 100%;
    width: 100%;
}
.modal-dialog div {
    width: 1px;
    top: calc(50% - 50px);
    left: calc(50% - 50px);
    position: fixed;
}

</style>
